<template>
<v-container fluid>
   <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
      >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          ESLIP NUMBER  {{ eslip.e_slipNumber }}
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="invoiceHeaders" :items="eslip.data" class="elevation-1" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="body-2 accent--text font-weight-medium"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.marketer.organisationName }}</td>
              <td>{{ props.item.invoiceAmount }}</td>
              <td>{{ props.item.totalWeight }}</td>
              <td>{{ props.item.created | prettyDate }}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn color="secondary" @click="hideDialog"> Close </v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
   <v-row>
     <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="6" md="4">
                <v-text-field v-model="search" append-icon="search" label="Search by Number"
                single-line hide-details color="primary"></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
              <v-data-table :headers="headers" :items="eslips" :search="search" disable-pagination
                :hide-default-footer="true" class="elevation-1">
                <template v-slot:[`item.created`]="{ item }">
                  {{item.dateCreated | prettyDate }}
                </template>
              </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="9">
                <v-pagination v-model="page" :length="totalPages" total-visible="7" next-icon="mdi-menu-right"
                  prev-icon="mdi-menu-left" @input="handlePageChange"></v-pagination>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
     </v-col>
   </v-row>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import _ from 'lodash'

export default {
	name: 'buyereslips',
	data: function () {
		return {
			headers: [
				{ text: 'BUYER', value: 'buyer.organisationName' },
				{ text: 'ESLIP NUMBER', value: 'eslipNumber' },
				{ text: 'AMOUNT', value: 'eslipAmount' },
				{ text: 'AMOUNT PAID', value: 'amountPaid' },
				{ text: 'TOTAL WEIGHT', value: 'eslipWeight' },
				{ text: 'STATUS', value: 'status.statusName' },
				{ text: 'DATE CREATED', value: 'created' }
			],
			eslips: [],
			message: '',
			loading: false,
			totalEslips: 0,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			pagination: { sortBy: 'id', descending: true },
			dialog: false,
			invoiceHeaders: [
				{ text: 'Invoice ID', value: 'Invoice ID', sortable: false },
				{ text: 'Marketer', value: 'marketer', sortable: false },
				{ text: 'Amount', value: 'Amount', sortable: false },
				{ text: 'Weight', value: 'weight', sortable: false },
				{ text: 'Invoice Date', value: 'created', sortable: false }
			],
			eslip: {},
			search: '',
			page: 1,
			totalPages: 0,
			pageSize: 7,
			pageSizes: [5, 10]
		}
	},
	watch: {
		search: function (newSearch) {
			// Reset page number when search changes
			this.page = 1
			this.debouncedGetEslips()
		}
		// search: function (oldValue, newValue) {
		//   this.debouncedGetAnswer()
		// }
	},
	mounted () {
		this.getBuyerEslips()
	},
	methods: {
		getRequestParams (name, page, pageSize) {
			const params = {}
			if (page) {
				params.page = page - 1
			}
			if (pageSize) {
				params.size = pageSize
			}
			if (name) {
				params.eslipNumber = name
			}
			return params
		},
		getBuyerEslips () {
			const params = this.getRequestParams(this.search, this.page, this.pageSize)
			const url = config.serverURI + '/eslip/buyer'
			axios.get(url, { params })
				.then(response => {
					console.log('Eslip data', response.data)
					const { items, totalPages } = response.data
					this.eslips = items
					this.totalPages = totalPages
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.eslips
		},
		triggerDownload (item) {
			const url = config.serverURI + '/eslip/download/' + item.id
			axios({ url: url, method: 'POST', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = item.buyer.organisationName + '_' + item.created + '.pdf'
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		displayEslipDetails (item) {
			this.dialog = true
			this.eslip = item
		},
		hideDialog () {
			this.dialog = false
		},
		handlePageChange (value) {
			this.page = value
			this.getBuyerEslips()
		},
		handlePageSizeChange (size) {
			this.pageSize = size
			this.page = 1
			this.getBuyerEslips()
		}
	},
	// created: function () {
	//   this.debouncedGetAnswer = _.debounce(this.getGrowerStatement, 1000)
	// },
	debouncedGetEslips: _.debounce(function () {
		this.getBuyerEslips()
	}, 500)
}

</script>
<style>
</style>
